import { useRouter } from "next/router";
import { useMemo } from "react";

/**
 * @param {string} key
 * @returns {boolean | undefined}
 */
export default function useRouterBoolean(key) {
  const router = useRouter();

  const value = useMemo(() => {
    if (typeof router.query[key] === "string") {
      if (router.query[key] === "1") {
        return true;
      }
      if (router.query[key] === "0") {
        return false;
      }
    }
    return undefined;
  }, [key, router.query]);

  return value;
}
